angular.module('leanlaw').filter('billingType', ['lists', function (lists) {
  return function (entry) {
    if (!entry || !entry.billingType) return '';
    const type = lists.entryBillingTypes.find(item => item.id === entry.billingType);
    return type ? type.label : entry.billingType;
  };
}]);